<template>
  <span
    class="viq-citation-pill"
    :title="source ? source.title : 'Source ' + number"
    @click="handleClick"
  >
    [{{ number }}]
  </span>
</template>

<script>
export default {
  name: "ViqCitationPill",
  props: {
    number: {
      type: [Number, String],
      required: true,
    },
    source: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handleClick() {
      if (this.source) {
        this.$store.dispatch("Viq/openSlideOut", this.source);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-citation-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  padding: 0 5px;
  background: $viq-citation-bg;
  color: $viq-accent;
  font-size: 11px;
  font-weight: 700;
  border-radius: $viq-radius-sm;
  cursor: pointer;
  vertical-align: super;
  transition: background $viq-transition-fast, color $viq-transition-fast;

  &:hover {
    background: $viq-accent;
    color: #fff;
  }
}
</style>
